<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Obra</span>
        <h3 class="page-title d-inline">Editar</h3>
        <d-link v-if="!isCustomer" class="btn btn-success text-white float-right " href="/admin/obras/novo">Novo obra</d-link>
        <d-button v-if="!isCustomer" type="button" @click.prevent="submit" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <project-page :project="project" ref="projectForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProjectPage from '_modules/project/components/ProjectPage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/ProjectModel';

export default {
  name: 'project-edit',
  components: {
    ProjectPage,
  },
  computed: {
    project() {
      const { project } = this.$store.state.project;
      if (project) {
        Events.$emit(_LOAD_MODEL_, project);
        return project;
      }
      return MODEL;
    },
  },
  data() {
    return {
      isCustomer: false,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getProject',
      'checkIsCustomer',
    ]),
    checkUser() {
      this.checkIsCustomer().then(response => {
        this.isCustomer = response;
      });
    },
    getProjectModel() {
      this.setToggle({ type: 'progress', bool: true });
      this.getProject(parseInt(this.$route.params.projectId, Number))
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    submit() {
      this.$refs.projectForm.submit();
    },
  },
  mounted() {
    this.checkUser();
    if (this.$route.params.projectId) {
      this.getProjectModel();
    }
  },
};
</script>
